import React, { useState, useEffect, useRef, Fragment } from "react";
import gsap from "gsap";
import style from './dropdown.module.css'
import Icons from '../../module.icons';
import classNames from "classnames";

function Dropdown(props) {
    const parentRef = useRef();
    const eleRef = useRef();
    const choicesRef = useRef();

    function buildFlat(choices) {
      if (!choices) return null;
      let flat = [];
      choices.forEach((obj) => {
        flat.push(obj);
        obj.children.forEach((obj2) => {
          flat.push(obj2);
          obj2.children.forEach((obj3) => {
            flat.push(obj3);
          });
        });
      });
      return flat;
    }

    const [flatChoices, setFlatChoices] = useState(() => buildFlat(props.choices));
    const [active, setActive] = useState(false);

    function animDropDown(open) {
        if (open) {
          let parent = parentRef.current.offsetLeft;
          let dropDownElem = eleRef.current.offsetLeft;
          let offsetLeft = parent - dropDownElem;

          console.log('animDropDown', parent, dropDownElem, offsetLeft)
          var tl = gsap.timeline();
          tl.to(
            choicesRef.current,
            { height: "auto", duration: 0 }
          );
          tl.to(
            eleRef.current,
            { zIndex: 3, x: offsetLeft, height: "auto", duration: 0 },
            "<"
          );
          tl.to(eleRef.current, {
            scale: 1,
            opacity: 1,
            duration: 0.1,
          });
        } 
        else {
          gsap.to(".dropDownChoices", { height: 0, duration: 0 });
          gsap.to(".dropDownField", {
            opacity: 0,
            scale: 0,
            zIndex: -1,
            duration: 0.1,
          });
        }
      }
    

    function onClickDD(field) {
        if (field === active) {
            setActive(null);
          } else {
            setActive(field);
          }
    }

    useEffect(() => {
        animDropDown(active)
    }, [active])

    useEffect(() => {
      console.log('props.selection', props.selection)
    }, [props.selection])

    useEffect(() => {
      console.log('props.choices', props.choices)
      if (props.choices){
        setFlatChoices(buildFlat(props.choices));
      }

    }, [props.choices])

    function onSelection(objId){
      props.onSelection(objId)
      setActive(null)
    }

    // function getSelectionText(){
    //   return flatChoices.find(a => a.id === props.selection)[props.selectionField]
    // }

    
    return (
        <div className="dropDownRow" ref={parentRef}>
        <div
          className="ui fontBtn"
          onClick={(e) => onClickDD(props.name)}
        >

            {flatChoices && <span className="canvasLabel" dangerouslySetInnerHTML={{__html: props.selection ? flatChoices.find(a => a.id === props.selection)[props.selectionField]
             : "Select Folder" }}/>}
          

          <Icons.ChevronDown className="icon" />
        </div>
        <span
          className="inputField dropDownField"
         ref={eleRef}
        >
          <span className="dropDown">
            <span className={classNames(style.choices)} ref={choicesRef}>
              {props.choices
                .sort((a, b) => a.ordering - b.ordering)
                .map((obj, i) => (
                  <span key={"fileCategory_" + i} >
                    <span className={classNames(style.choice, "ui")} onClick={() =>
                        onSelection(obj.id)
                      } dangerouslySetInnerHTML={{__html: obj.text}} />

                      {obj.children
                        .sort((a, b) => a.ordering - b.ordering)
                        .map((obj2, i) => (
                            <span key={"fileCategorySub_" + i} >
                              <span className={classNames(style.choice, "ui", style.subChoice)} onClick={() =>
                                onSelection(obj2.id)
                              } dangerouslySetInnerHTML={{__html: obj2.text}} />
                              {obj2.children
                                .sort((a, b) => a.ordering - b.ordering)
                                .map((obj3, i) => (
                                    <span key={"fileCategorySubSub_" + i} className={classNames(style.choice, "ui", style.subSubChoice)} onClick={() =>
                                        onSelection(obj3.id)
                                      } dangerouslySetInnerHTML={{__html: obj3.text}} />
                                ))}
                            </span>
                        ))}
                  </span>
                ))}
                <span className={classNames(style.choice, "ui", style.noneChoice)} onClick={() =>
                  onSelection(null)
                }>None</span>
            </span>
          </span>
        </span>
      </div>
    )
}

export default Dropdown;
